import React from 'react';
import bannersModule, { BannerTypes } from '@gin-betting/banners';

import useBanners from './useBanners';
import Banner from '../Banner';

const {
    hocs: { withAvailableZoneByAttributes },
} = bannersModule;

interface OwnProps {
    zoneLocation: BannerTypes.BannerZoneLocation;
}

type Props = OwnProps & BannerTypes.WithAvailableZoneProps;

const Banners: React.FC<Props> = React.memo(({ zoneId, zoneLocation }) => {
    const { banners } = useBanners({ zoneId });

    return (
        <React.Fragment>
            {banners.map((banner, idx) => (
                <Banner key={idx} banner={banner} zoneLocation={zoneLocation} />
            ))}
        </React.Fragment>
    );
});

export default withAvailableZoneByAttributes<Props>(Banners);
